/**
 * TinyMCE iframe display styles only.
 * `zoom` affects editor rendering — it is not written into saved HTML or preview.
 */
export const TINYMCE_FONT_SIZE_FORMATS = "8pt 10pt 12pt 14pt 18pt 24pt 36pt";

export const TINYMCE_EDITOR_HEIGHT = 400;

export const TINYMCE_EDITOR_CONTENT_STYLE = `
  body { font-family: Arial, sans-serif; padding: 1rem; margin: 0; zoom: 0.72; font-size: 12pt; }
  p { margin: 0; }
`;
